// src/pages/misc/onboarding/OnboardingPlainReturnPage.tsx
// [HANDOFF] THE PLAIN RETURN (the `/` door's screen for `?status=success` and `?status=cancelled` - routed at WU-145's switch, P-5;
//   docs/manifest/WU-145.md SESSION 2 RECORD THE DESIGN D4 and THE SELF-STAMPS 3 to 6, SESSION 8 RECORD THE SELF-STAMPS 16 to 18).
//   Stripe sends the old lane and staff-provisioned Elite back to ventaje.com with a status and no application id. The door reads
//   the status and passes `cancelled`; the screen says the payment was received, or was cancelled, and leads to the app's login by
//   its one gold link. It reads no server and no id, and it has no timer. A screen he did not draw, in his style, inside his
//   OnboardingFrame at the return page's place on the bar.
import React from 'react';
import { useTranslation } from '../../../contexts/languages/LanguageContext';
import { publicJourney } from './continuousPath';
import OnboardingFrame from './OnboardingFrame';
import { LOGIN_URL } from './OnboardingReturnPage';
import { loadStructureDraft } from './structureDraft';
import './builder.css';
import '../../settings/create-organization/orgFlow.css';

const OnboardingPlainReturnPage: React.FC<{ cancelled: boolean }> = ({ cancelled }) => {
  const { t } = useTranslation();
  const progress = publicJourney(loadStructureDraft().path, 'checkout');
  const title = cancelled
    ? t('publicOnboarding.plainReturn.cancelled')
    : t('publicOnboarding.plainReturn.received');
  const gold = 'btn-gold inline-flex items-center justify-center min-h-[48px] px-6 rounded-xl text-sm font-bold';

  return (
    <OnboardingFrame step={progress.step} total={progress.total} band="card">
      <div className="ob-flow-copy">
        <h1 className="ob-flow-title">{title}</h1>
      </div>
      <div className="org-float">
        <a className={gold} href={LOGIN_URL}>
          {t('publicOnboarding.return.login')}
        </a>
      </div>
    </OnboardingFrame>
  );
};

export default OnboardingPlainReturnPage;
